import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { PageHeader } from "components/ui";
import TabLink from "components/ui/tab-list/tab-link";
import useDateRange from "hooks/useDateRange";
import DateRange from "components/ui/date-range";
import moment from "moment";
import SynthpopMetrics from "./synthpop-metrics";
import SynthpopCallLogsTable from "./synthpop-call-logs-table";
import AICallJobManagement from "./synthpop-job-management";
import SynthpopTesting from "./synthpop-testing";
import "./agent-calling-dashboard.scss";

const AgentCallingDashboard = () => {
  const { path } = useRouteMatch();
  const { startDate, endDate, setStartDate, setEndDate, dateRangeIsValid } =
    useDateRange({
      startDate: moment().subtract(7, "days").format("MM/DD/YYYY"),
      endDate: moment().format("MM/DD/YYYY")
    });

  return (
    <div className="agent-calling-dashboard">
      <PageHeader title="Agent Calling">
        <DateRange
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
          isValid={dateRangeIsValid}
          showSubmit={false}
          startLabel="Start:"
          endLabel="End:"
        />
      </PageHeader>
      <div className="company-menu no-print">
        <ul className="tab-list">
          <TabLink path={`${path}`} label="Metrics" exact />
          <TabLink path={`${path}/call-logs`} label="Call Logs" />
          <TabLink path={`${path}/job-manager`} label="Job Manager" />
          <TabLink path={`${path}/testing`} label="Testing" />
        </ul>
      </div>
      <Switch>
        <Route path={`${path}`} exact>
          <SynthpopMetrics startDate={startDate} endDate={endDate} />
        </Route>
        <Route path={`${path}/call-logs`}>
          <SynthpopCallLogsTable startDate={startDate} endDate={endDate} />
        </Route>
        <Route path={`${path}/job-manager`}>
          <AICallJobManagement startDate={startDate} endDate={endDate} />
        </Route>
        <Route path={`${path}/testing`}>
          <SynthpopTesting />
        </Route>
      </Switch>
    </div>
  );
};

export default AgentCallingDashboard;
